/* unplugin-vue-components disabled */import { render } from "./principalbly.vue?vue&type=template&id=23837821"
import script from "./principalbly.vue?vue&type=script&lang=js"
export * from "./principalbly.vue?vue&type=script&lang=js"

import "./principalbly.vue?vue&type=style&index=0&id=23837821&scope=true&lang=css"

import exportComponent from "/Users/huangzhichao/Code/beyoung/weitu_land_page_h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__